export function deleteAllNonDigits(string: string): string {
  return string.replace(/\D/g, '');
}
